// Client-side page meta helper: sets document title, description and social (OG/Twitter) tags.
function setTag(attr, key, value) {
  if (value == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

export function applyMeta({ title, description, image, url } = {}) {
  if (title) document.title = title;
  if (description) setTag("name", "description", description);
  if (title) setTag("property", "og:title", title);
  if (description) setTag("property", "og:description", description);
  if (image) setTag("property", "og:image", image);
  setTag("property", "og:type", "website");
  setTag("property", "og:url", url || window.location.href);
  setTag("name", "twitter:card", image ? "summary_large_image" : "summary");
  if (title) setTag("name", "twitter:title", title);
  if (description) setTag("name", "twitter:description", description);
  if (image) setTag("name", "twitter:image", image);
}

export function setFavicon(href) {
  if (!href) return;
  let link = document.head.querySelector('link[rel="icon"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "icon");
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
}
